import Switch from "../Switch";

interface ToggleOptionProps {
  label: React.ReactNode;
  name: string;
  checked: boolean;
  className?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ToggleOption: React.FC<ToggleOptionProps> = ({
  label,
  name,
  checked,
  className,
  onChange,
}) => {
  return (
    <div className={`gap-g-1 flex w-full items-center ${className ?? ""}`}>
      <span>{label}</span>
      <span className="grow"></span>
      <Switch name={name} checked={checked} onChange={onChange} />
    </div>
  );
};
